// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1sHqD","file":"styles_file__3nbBq"};